import _ from 'lodash';
import { getAuthHeaders } from '@/utils/authentication_headers';
import { APP_UUID } from '@/constants';

const authenticationRequestInterceptor = (config) => {
  const override = config;
  const headers = getAuthHeaders();

  // Pass APP_UUID in order to distinguish between apps
  override.headers['app-uuid'] = APP_UUID;
  override.headers['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';

  // Only apply stored auth headers if the request hasn't already set them explicitly
  // (e.g. password reset uses the token from the URL, not the stored session token)
  _.forEach(headers, (value, key) => {
    if (!override.headers[key]) {
      override.headers[key] = value;
    }
  });

  return config;
};

export default [
  authenticationRequestInterceptor,
];



// WEBPACK FOOTER //
// ./src/api/request_interceptors.js